import * as React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link } from "react-router-dom";
import { Button, Grid, TextField, FormControl, FormControlLabel, Select, MenuItem, FormGroup, Checkbox, RadioGroup, Radio } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { callApi } from '../../common/api';
import { userType } from '../../utils/constant';
import CustomizedSnackbars from "../alert/alert";
import { width } from '@mui/system';
import { useLocation } from 'react-router-dom';
import PhoneInput, { isValidPhoneNumber, isPossiblePhoneNumber } from "react-phone-number-input";
import "../Investor/style/GeneralDetailUpdate.css";
import debounce from 'lodash/debounce';


function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function RegisterAsInvestor() {
  const location = useLocation();
  React.useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const level = queryParams.get('level')
    if (level != null) {
      getDetails()
      setValue(parseInt(level))
    }
  }, [])
  const [next, setNext] = React.useState(false);
  const [terms, setTerms] = React.useState(false);
  const [isFormFilled, setIsFormFilled] = React.useState(false)
  const [user, setUser] = React.useState({
    firstName: "",
    middleName: "",
    lastName: "",
    country: "",
    linkedin: "",
    occupation: "",
    investmentExperience: "",
    workExperience: "",
    investmentTheme: "",
    totalPortfolioValue: "",
    investmentRestriction: "",
    phone: ''
  });
  const [snackBarMsg, setSnackBarMsg] = React.useState({
    message: "",
    severity: "success",
    open: false,
  });

  const [value, setValue] = React.useState(0);
  const [phoneValid, setPhoneValid] = React.useState(true)
  const [countries, setCountries] = React.useState([]);
  const [errors, setErrors] = useState({});
  // const [salaryType , setSalaryType] = React.useState({})
  const theme = ["Production"];
  const inputStyles = {
    color: 'white', // Specify your desired font color

  };

  const [mobile, setMobile] = React.useState(user.phone);

  const handlePhoneNumberChange = (value) => {
    setMobile(value);
  };

  React.useEffect(() => {

    setUser((prevState) => ({
      ...prevState,
      phone: mobile,
    }));
  }, [mobile])


  // React.useEffect(() => {
  //   if (mobile && !isValidPhoneNumber(mobile)) {
  //     setPhoneValid(false);
  //     setSnackBarMsg({
  //       message: 'Invalid phone number.',
  //       severity: 'warning',
  //       open: true,
  //     });
  //   } else {
  //     setPhoneValid(true);
  //   }
  // }, [mobile]);

  
  const handleInput = () => {
    setNext(!next)
  }
  
  async function getAllCountries() {
    const response = await callApi("get", "country/getCountry?step=1");
    setCountries(response?.data?.data)
  }
  // async function getUserType() {
  //     const response = await callApi("get", "enums/getSalaryType");
  //     setSalaryType(response.data.data)
  // }
  React.useEffect(() => {
    getAllCountries();
    // getUserType();
  }, [])

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (event && event.target.name !== 'country') {
      if (event.target.hasAttribute('data-numeric')) {
        if (!/^[0-9]*$/.test(value)) {
          setSnackBarMsg({
            message: 'This should be a number',
            severity: 'warning',
            open: true,
          });
        } else {
          setSnackBarMsg({
            message: '',
            severity: 'warning',
            open: false,
          });
          setUser((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        }
        return;
      }
    }
  

    if (name === 'firstName' || name === 'middleName' || name === 'lastName' || name === 'occupation' || name === 'investmentTheme') {
      if (!/^[A-Za-z\s]*$/.test(value)) {
        setSnackBarMsg({
          message: `Enter alphabets only for ${name != "investmentTheme" ? name : "Investment Sector"}.`,
          severity: 'warning',
          open: true,
        });
        return;
      } else {
        setUser((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
      return;
    }

    if (name == 'phone') {
      if (value !== "" && !/^[0-9+]+$/.test(value)) {
        setSnackBarMsg({
          message: `Enter numbers only for ${name}.`,
          severity: 'warning',
          open: true,
        });
        return;
      } else {
        setUser((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
      return;
    }
    else {
      setUser((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    localStorage.setItem(name, value)
  };

  const handleChangeGoBack = (newValue) => {
    setValue(newValue);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleButtonChange = async (tabIndex) => {
    try {
      let documentReq = {};
      const { middleName, investmentExperience,
        workExperience,
        investmentTheme,
        totalPortfolioValue,
        investmentRestriction, ...otherFields } = user;
      const isAnyFieldEmpty = Object.values(otherFields).some(value => value === "" || value === null);
      if (isAnyFieldEmpty) {
        // Show the snackbar with an error message
        setSnackBarMsg({
          message: "Please fill all required fields.",
          severity: "error",
          open: true,
        });
        return; // Stop further execution of the function
      }
      // linkedin validation---
      if (!/^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/(in|pub|public-profile\/in|public-profile\/pub)\/([a-zA-Z0-9\-_]+)(?:\/[a-zA-Z0-9\-_]+)*\??(?:[^\s]+=[^\s&]+&?)*$/.test(user.linkedin))  {
        setSnackBarMsg({
          message: "Enter a valid LinkedIn URL.",
          severity: "warning",
          open: true,
        });

        return;
      }
      if (!phoneValid) {
        setSnackBarMsg({
          message: "Invalid Phone Number",
          severity: "error",
          open: true
        })
        return
      }
      for (let key in user) {
        if (key === "linkedin") {
          documentReq[key] = user[key];
        }
      }

      let documentAPI;
      if (documentReq) {
        documentAPI = await callApi("post", "document/upload", documentReq);
      }
      const { data, status } = documentAPI;
      const documentId = [];
      if (data.status) {
        for (let i of data.data.Document) {
          documentId.push(i.id)
        }

      }
      let obj = {
        firstName: user.firstName,
        middleName: user.middleName,
        lastName: user.lastName,
        country: user.country,
        occupation: user.occupation,
        userType: userType.investor,
        documentIds: documentId,
        phone: user.phone,
      }

      const response = await callApi("post", "userRegister/userDetails", obj);

      if (data.status) {
        //   setSnackBarMsg({
        //     message:"successfully registered",
        //     severity:"success",
        //     open:true,
        //   });
        setValue(tabIndex);
        setIsFormFilled(true)
        localStorage.setItem("name", (user.firstName + " " + user.lastName))
      }
    } catch (error) {
      if (error.response) {
        setSnackBarMsg({
          message: error.response.data?.response?.message || error.response.data.message,
          severity: "error",
          open: true,
        });
      } else if (error.request) {
        setSnackBarMsg({
          message: "An error occurred while processing your request.",
          severity: "error",
          open: true,
        });
      } else {
        setSnackBarMsg({
          message: "An error occurred while processing your request.",
          severity: "error",
          open: true,
        });
      }
    }
  };

  const phoneInput = () => {
    const isValid = isPossiblePhoneNumber(user.phone || "")
    if (user.phone) {
      if (!isValid) {
        setSnackBarMsg({
          message: "Please Enter valid phone number",
          severity: "error",
          open: true
        })
        setPhoneValid(false)
        return

      } else {
        setPhoneValid(true)
      }
    }
    else {
      return;
    }
  }


  const handleSignUp = async (e) => {
    e.preventDefault();
    // if (terms === false) {
    //   setSnackBarMsg({
    //     message: "Please accept the to our terms and conditions.",
    //     severity: "error",
    //     open: true,
    //   });
    //   return;
    // }
    const { middleName, investmentRestriction, ...otherFields } = user;
    let obj = {
      investmentExperience: user.investmentExperience,
      workExperience: user.workExperience,
      investmentSector: user.investmentTheme,
      investedStartup: user.totalPortfolioValue,
      investmentRestriction: user.investmentRestriction,
      termAndCondition: terms
    }
    const isAnyFieldEmpty = Object.values(otherFields).some(value => value === "" || value === null);
    if (isAnyFieldEmpty) {
      setSnackBarMsg({
        message: "Please fill in all the fields.",
        severity: "error",
        open: true,
      });
      return;
    }
    if (next && !investmentRestriction) {
      setSnackBarMsg({
        message: "Please fill in the Investment Restriction field as it is required.",
        severity: "error",
        open: true,
      });
      return;
    }
    if (terms === false) {
      setSnackBarMsg({
        message: "Please accept the to our terms and conditions.",
        severity: "error",
        open: true,
      });
      return;
    }

    const response = await callApi("post", "investor/investorRegister", obj);
    if (response.data.response.status) {
      setSnackBarMsg({
        message: "Saved Successfully",
        severity: "success",
        open: true,
      });

      let allData = localStorage.getItem("AllData");


      let parsed = JSON.parse(allData);


      parsed.registrationStep = 3;


      localStorage.setItem("AllData", JSON.stringify(parsed));

      window.location.href = "/discover";
    } else {
      setSnackBarMsg({
        message: "Please fill in all the fields.",
        severity: "error",
        open: true,
      });
    }
  }

  async function getDetails() {
    try {
      const response = await callApi('get', 'userRegister')
      const data = response.data.response.data
      localStorage.setItem('AllData', JSON.stringify(data))
      setUser({
        ...user,
        firstName: data.firstName,
        lastName: data.lastName,
        middleName: data.middleName,
        occupation: data.occupation,
        country: data.country,
        linkedin: data?.userDocuments[0]?.link,
        phone: data.phone
      });
    } catch (error) {
      console.log(error, "error")
    }
  }
  React.useEffect(() => {
    getDetails()
  }, [isFormFilled, value])

  const termsInput = () => {
    setTerms(!terms)
  }

  const handlePhoneKeyDown = (e) => {
    const { name } = e.target
    if (name === 'firstName' || name === 'middleName' || name === 'lastName' || name === 'occupation') {
      if (!/^[A-Za-z\s]*$/.test(e.key)) {
        e.preventDefault();
        setSnackBarMsg({
          message: `Enter alphabets only for ${name}.`,
          severity: 'warning',
          open: true,
        });
        return;
      }
    }

    if (name === "phone") {
      if (user?.phone?.length == 15 && e.key !== 'Backspace') {
        e.preventDefault();
        setSnackBarMsg({
          message: "Phone number cannot be more than 15 digits",
          severity: 'warning',
          open: true,
        });
        return;
      }
      if (!/^[0-9+]+$/.test(e.key) && (e.key !== 'Backspace' && e.key !== "Shift" && e.key !== 'Unidentified')) {
        e.preventDefault();
        setSnackBarMsg({
          message: `Enter numbers only for ${e.target.name}.`,
          severity: 'warning',
          open: true,
        });
        return;
      } else {
        console.log("This is phone else if")
      }
    }
    return;
  };

  return (
    <>
      <div id="main" >
        <section className="commonspace investorformpage  bg_black">
          <div className="container">
            <div className="bg_dark_grey p-5 border_rad_8">
              <div className="commanhead mb-5 text-center text-white">
                <h2 className="subhead startup-heading">Register as an Investor</h2>
              </div>
              <Tabs sx={{
                '& .MuiTabs-indicator': {
                  backgroundColor: 'white',
                  fontSize: '22px'
                },
              }} value={value} variant="fullWidth" onChange={handleChange} aria-label="basic tabs example">
                <Tab style={{ width: '100%', color: value === 0 ? "white" : "#A9A9A9" }} label={<div style={{ display: "flex", gap: "8px" }}> <div className='tab' style={{ width: "20px", height: '20px', backgroundColor: value === 0 ? "white" : "#A9A9A9", color: "black", borderRadius: "50%", alignItems: 'center', justifyContent: 'center', display: 'flex' }}>1</div><Typography variant='body2' className='body2 tabText'>Personal Information</Typography></div>} {...a11yProps(0)} />
                <Tab style={{ width: '100%', color: value === 1 ? "white" : "#A9A9A9" }} label={<div style={{ display: "flex", gap: "8px" }}> <div className='tab' style={{ width: "20px", height: '20px', backgroundColor: value === 1 ? "white" : "#A9A9A9", color: "black", borderRadius: "50%", alignItems: 'center', justifyContent: 'center', display: 'flex' }}>2</div><Typography variant='body2' className='body2 tabText'>Investment Information</Typography></div>} {...a11yProps(1)} />
              </Tabs>
              <div className="tab-content" id="ex1-content">
                <CustomTabPanel value={value} index={0}>

                  <div className="investorform">
                    <form>
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">First Name<span>*</span></label>
                            <input type="text" className="form-control" name="firstName" value={user.firstName} onKeyDown={handlePhoneKeyDown} onChange={handleInputChange} placeholder="Enter first name" />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Middle Name</label>
                            <input type="text" className="form-control" name="middleName" value={user.middleName} onKeyDown={handlePhoneKeyDown} onChange={handleInputChange} placeholder="Enter middle name" />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Last Name<span>*</span></label>
                            <input type="text" className="form-control" name="lastName" value={user.lastName} onKeyDown={handlePhoneKeyDown} onChange={handleInputChange} placeholder="Enter last name" />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Country of Citizenship<span>*</span></label>
                            <Select
                              className="form-control"
                              id="invesmentRound"
                              style={{ backgroundColor: "#121212", border: "1px #575555 solid", borderRadius: "8px", color: "#fff", fontSize: "14px", height: "40px" }}
                              onChange={handleInputChange}
                              name="country"
                              value={user.country}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {countries?.map((option, index) => {
                                return (
                                  <MenuItem key={index} value={option.name}>
                                    {option.name} {option.flag}
                                  </MenuItem>

                                )
                              })}
                            </Select>
                          </div>
                        </div>


                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Occupation<span>*</span></label>
                            <input type="text" className="form-control" name="occupation" value={user.occupation} onKeyDown={handlePhoneKeyDown} onChange={handleInputChange} placeholder="Enter Occupation" />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Linkedin  Profile URL<span>*</span></label>
                            <input type="text" className="form-control" name="linkedin" value={user.linkedin} onChange={handleInputChange} placeholder="Enter Linkedin  Profile URL" />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Phone<span>*</span></label>
                            <PhoneInput onBlur={phoneInput} defaultCountry="IN" type="text" className="form-control phone-input1 phoneBorderRadius" name="phone" value={user.phone} onChange={handlePhoneNumberChange} onKeyDown={handlePhoneKeyDown} placeholder="Enter Phone No." />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-end mt-4">
                        <button type="submit" onClick={(e) => {

                          e.preventDefault()
                          handleButtonChange(1)
                        }} className="btn btn-primary">Next</button>
                      </div>
                    </form>
                  </div>
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                  <div className="investorform">
                    <form>
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Year of Investment Experience<span>*</span></label>
                            <input
                              type="text"
                              data-numeric
                              className="form-control"
                              name="investmentExperience"
                              value={user.investmentExperience}
                              onChange={handleInputChange}
                              placeholder="Enter Year of Investment"
                            />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Work Experience<span>*</span></label>
                            <input type="text" data-numeric className="form-control" name="workExperience" value={user.workExperience} onChange={handleInputChange} placeholder="Enter Work Experience" />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">Investment Sector<span>*</span></label>
                            <input type="text" className="form-control" name="investmentTheme" value={user.investmentTheme} onChange={handleInputChange} placeholder="Enter Investment Sector" />
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                          <div className="mb-3">
                            <label className="form-label text-white-50">How many startup invested in<span>*</span></label>
                            <input data-numeric className="form-control" name="totalPortfolioValue" value={user.totalPortfolioValue} onChange={handleInputChange} placeholder="Invested In" />
                          </div>
                        </div>


                        {next ? (
                                <div className="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                                  <div className="mb-3">
                                    <label className="form-label text-white-50">
                                      Investment Restriction<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className={`form-control ${errors.investmentRestriction ? 'is-invalid' : ''}`}
                                      name="investmentRestriction"
                                      value={user.investmentRestriction}
                                      onChange={handleInputChange}
                                      placeholder="Investment Restriction"
                                      required={next}
                                    />
                                    {errors.investmentRestriction && (
                                      <div className="invalid-feedback">{errors.investmentRestriction}</div>
                                    )}
                                  </div>
                                </div>
                              ) : null}
                              
                              <FormGroup sx={{ color: 'white' }}>
                                <FormControlLabel
                                  control={<Checkbox sx={{ color: 'white !important' }} checked={next} onChange={handleInput} />}
                                  label={<div className="text-white">Any investment preference/restriction (certain industries or sectors)</div>}
                                />
                       <FormControlLabel
                         control={<Checkbox sx={{ color: "white !important" }} />}
                         label={<div className="text-white">Are you comfortable investing in international markets or domestic markets?</div>}
                       />
                       <FormControlLabel
                         control={<Checkbox sx={{ color: "white !important" }} checked={terms} onChange={termsInput} />}
                         label={<div className="text-white">You Agree to Our Investor <Link target="_blank" to={`${process.env.REACT_APP_CMSFE_URL}/termsAndCondition`}>Terms & Conditions</Link><span style={{ color: "red" }}>*</span></div>}
                       />
                     </FormGroup>

                      </div>

                      <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-end my-2 d-flex justify-content-between mt-5" style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <button id='transparent' style={{ backgroundColor: "inherit", color: "white", border: "1px solid white" }} onClick={() => handleChangeGoBack(0)} type="submit">Go Back</button>
                        <button id='trans' onClick={handleSignUp} type="submit" className="btn btn-primary">Sign Up</button>
                      </div>
                    </form>
                  </div>

                </CustomTabPanel>
              </div>
            </div>
          </div>
        </section>


      </div>


      <CustomizedSnackbars
        msgData={snackBarMsg}
        setMsgData={setSnackBarMsg}
      />

    </>
  );
}

